import React, { memo } from 'react';
import SVG from 'react-inlinesvg';
import { useTranslation } from 'react-i18next';
import Tooltip from '@material-ui/core/Tooltip';
import CircularLoader from '../../../shared/components/CircularLoader/CircularLoader';
import { useUptimeData } from '../../hooks/useUptimeData';
import styles from './activityTime.module.scss';

export default memo(function ActivityTime(props) {
    const [t] = useTranslation(['common', 'dashboard']);

    useUptimeData(props.getUptimeRequest);

    return (
        <div className={styles.container}>
            <div className={styles.informationContainer}>
                <Tooltip className={styles.title} disableFocusListener disableTouchListener title={t('dashboard:system_date')}>
                    <div>
                        <SVG cacheGetRequests className={styles.icon} src="./icons/calendar.svg" />
                        <span>{t('dashboard:system_date')}</span>
                    </div>
                </Tooltip>
                <div className={styles.valueContainer}>
                    {props.uptime.fetching && <CircularLoader size={24} />}
                    {
                        !props.uptime.fetching &&
                        props.uptime.error &&
                        props.uptime.now &&
                        <Tooltip
                            className={styles.tooltip}
                            disableFocusListener
                            disableTouchListener
                            title={t('dashboard:update_error')}
                        >
                            <div>
                                <SVG cacheGetRequests className={styles.errorIcon} src="./icons/error.svg" />
                            </div>
                        </Tooltip>
                    }
                    {
                        props.uptime.error &&
                        !props.uptime.now &&
                        <span className={styles.value}>{t('common:no_information_available')}</span>
                    }
                    {
                        props.uptime.now &&
                        <span className={`${styles.value} ${styles.lowercase}`}>{props.uptime.now}</span>
                    }
                </div>
            </div>
            <div className={styles.informationContainer}>
                <Tooltip
                    className={styles.title}
                    disableFocusListener
                    disableTouchListener
                    title={t('dashboard:system_activity_time')}
                >
                    <div>
                        <SVG cacheGetRequests className={styles.icon} src="./icons/clock.svg" />
                        <span>{t('dashboard:system_activity_time')}</span>
                    </div>
                </Tooltip>
                <div className={styles.valueContainer}>
                    {props.uptime.fetching && <CircularLoader size={24} />}
                    {
                        !props.uptime.fetching &&
                        props.uptime.error &&
                        props.uptime.days &&
                        <Tooltip
                            className={styles.tooltip}
                            disableFocusListener
                            disableTouchListener
                            title={t('dashboard:update_error')}
                        >
                            <div>
                                <SVG cacheGetRequests className={styles.errorIcon} src="./icons/error.svg" />
                            </div>
                        </Tooltip>
                    }
                    {
                        props.uptime.error &&
                        !props.uptime.days &&
                        <span className={styles.value}>{t('common:no_information_available')}</span>
                    }
                    {
                        !props.uptime.error &&
                        !props.uptime.fetching &&
                        <span className={`${styles.value} ${styles.lowercase}`}>
                            {props.uptime.days} {t('common:day', { count: props.uptime.days })},&nbsp;
                            {props.uptime.hours}:{props.uptime.minutes} {t('common:hour', { count: props.uptime.hours })}
                        </span>
                    }
                </div>
            </div>
        </div >
    );
}, (prevProps, nextProps) =>
        prevProps.uptime === nextProps.uptime &&
        prevProps.getUptimeRequest === nextProps.getUptimeRequest
);
